/**
 * detectMath — cheap, entry-bundle-safe test for "does this markdown contain
 * TeX math we should render?" (CEL-2102).
 *
 * The heavy renderer (remark-math + rehype-katex + KaTeX CSS/fonts) is
 * lazy-loaded by useMathPlugins ONLY when this returns non-null, so the
 * entry bundle never pays for KaTeX.
 *
 * Only `$$...$$` counts (display on its own lines, or inline on one line).
 * Single-dollar `$...$` is NEVER math here, by design: CellCog content is
 * full of prices ("$25/shift", "[$25 (2,250 cr)](https://...)") and any
 * heuristic that switches remark-math's single-dollar mode on for one span
 * switches it on for the WHOLE message. The Sep-3 regression: `_r` inside a
 * Stripe `client_reference_id` URL read as a TeX subscript, the mode flipped,
 * and the price links around it rendered as a formula. There is no
 * full-proof single-dollar heuristic; `$$` is unambiguous, so that is the
 * whole gate. Agents wanting inline math write `$$E=mc^2$$`.
 *
 * Returns null (no math) or { singleDollar: false } — the value for
 * remark-math's `singleDollarTextMath` option (always false; the shape is
 * kept so useMathPlugins stays agnostic).
 */

// $$...$$ — display math (also matches inline $$..$$). Requires a non-`$`
// first char so "$$$" style runs don't match.
const DOUBLE_DOLLAR_RE = /\$\$[^$][\s\S]*?\$\$/;

export default function detectMath(content) {
  if (typeof content !== 'string' || content.indexOf('$$') === -1) return null;
  if (DOUBLE_DOLLAR_RE.test(content)) return { singleDollar: false };
  return null;
}
